import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const SearchCounts = ({ context, initialCount }) => {
  const searchStore = context.getStore('SearchStore');
  const paramStore = context.getStore('ParamStore');
  const facetStore = context.getStore('FacetStore');

  const [counts, setCounts] = useState();
  const setStateFromStores = () => {
    const activeFacets = facetStore.active(paramStore.activeFacetContexts());
    const keyword = paramStore.get('keywords');
    if (keyword) {
      activeFacets.unshift({ title: keyword, key: 'keywords' });
    }

    return activeFacets;
  };

  const [facets, setFacets] = useState(setStateFromStores());

  const onChange = () => {
    // eslint-disable-next-line no-underscore-dangle
    setCounts(searchStore._resultsCount);
    setFacets(setStateFromStores());
  };

  useEffect(() => {
    searchStore.addChangeListener(onChange);
    facetStore.addChangeListener(onChange);
    paramStore.addChangeListener(onChange);
    return () => {
      searchStore.removeChangeListener(onChange);
      facetStore.removeChangeListener(onChange);
      paramStore.removeChangeListener(onChange);
    };
  }, []);

  return (
    <span>
      {(counts === undefined ? initialCount : counts).toLocaleString()} results
      {facets.length ? <span className="hidden bs-xs:inline-block">:</span> : ''}
    </span>
  );
};

SearchCounts.propTypes = {
  context: PropTypes.object,
  initialCount: PropTypes.string
};
export default SearchCounts;
